// extracted by mini-css-extract-plugin
module.exports = {"questionsSection":"Questions_questionsSection__1Huqp","questionsHeader":"Questions_questionsHeader__fmNZc","questions":"Questions_questions__3znUT","link":"Questions_link__27CKZ"};